import ImportDonneesController from './importdonnees.form.controller';

export default {
    template: require('./importdonnees.form.html'),
    controller: ImportDonneesController
};
